module.exports = __webpack_public_path__ + "fonts/baronsans-ultrahairlineitalic-webfont.9e664cfb.woff";